module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-03-7eee1c5c5e7553e8847f33208d4471ba.jpg";